import * as sectionStyles from "../../styles/internal-page/section.module.scss";

import React, {Fragment} from "react";

import Actualite from "../shared/widgets/Actualite";
import Agenda from "../shared/widgets/Agenda";
import ChiffreCle from "../shared/widgets/ChiffreCle";
import Citation from "../shared/widgets/Citation";
import {Embedded} from "../shared/widgets/embedded/Embedded";
import Lien from "../shared/widgets/Lien";
import Marketing from "../shared/widgets/Marketing";
import Twitter from "../shared/widgets/Twitter";
import Youtube from "../shared/widgets/Youtube";
import clsx from "clsx";
import FocusContent from "../shared/widgets/FocusContent";
import Dispatch from "../shared/widgets/Dispatch";
import {altNN} from "../../utils/parsing";

const folderObjecLocaletMap = {
    "event-en": "events", "event-fr": "evenements", "news_item-en": "news", "news_item-fr": "actualites",
};

const getObjectUrl = (siteURL, slug, type, locale) => {
    if (slug) {
        const folderKey = `${type}-${locale}`;
        const uri = `/${siteURL}/${folderObjecLocaletMap[folderKey]}/${slug}`;
        return uri.replace(/\/\/+/g, "/");
    }
    return null;
};


const Section = ({
    content, title, tweets, youtubeVideos, siteURL, locale, spacing, three_columns
}) => {
    let indexTweet = 0;
    let indexYoutubeVideo = 0;
    let indexEventGuide = 0;
    let playableIndex = 0;
    const [playingVideoIndex, setPlayingVideoIndex] = React.useState(null);

    const sizeSpacing = 20;
    const column = (three_columns) ? 3 : 4;
    const chooseWidget = (elem) => {
        if (elem.__typename === "CmsPortalComponentWidgetTwitter" && tweets?.length > 0) {
            return <Twitter tweet={tweets[indexTweet++]}></Twitter>;
        }

        if (elem.__typename === "CmsPortalComponentWidgetYoutubeStream" && youtubeVideos?.length > 0) {
            return (<Youtube
                video={youtubeVideos[indexYoutubeVideo++]}
                playingVideoIndex={playingVideoIndex}
                setPlayingVideoIndex={setPlayingVideoIndex}
                index={playableIndex++}
            ></Youtube>);
        }

        if (elem.__typename === "CmsPortalComponentEventEventGuideFilter") {
            let event = elem.events?.length > indexEventGuide ? elem.events[indexEventGuide++] : null;
            return (<Agenda
                link={getObjectUrl(siteURL, event?.slug, "event", locale)}
                date={event?.start_date}
                title={event?.title}
                eventLanguage={event?.evt_language}
                locale={locale}
            ></Agenda>);
        }

        if (elem.__typename === "CmsPortalComponentWidgetEmbededContent") {
            return (<Embedded
                contentUrl={elem.content_link}
                playingVideoIndex={playingVideoIndex}
                setPlayingVideoIndex={setPlayingVideoIndex}
                index={playableIndex++}
            ></Embedded>);
        }

        if (elem.__typename === "CmsPortalComponentWidgetLink") {
            return (<Lien
                style={elem.style}
                link={elem.target_link}
                title={elem.titleLink}
                orientation={elem.titleOrientation}
                content={elem.content}
                alt={locale === "en" ? altNN(elem?.background?.alternativeTextEN) : altNN(elem?.background?.alternativeText)}
                text={elem.text}
                image={elem.background}
                frame={elem.frame}
                newWindow={elem.new_window}
            ></Lien>);

            /*return (
              <NewLink
                href={elem.target_link}
                title="Administration publique"
                content="Lorem ipsum dolor sit amet, consectetur adipiscing elit. "
                preview={elem.text}
                cover={elem.background}
              ></NewLink>
            );*/
        }

        if (elem.__typename === "CmsPortalComponentWidgetAgenda") {
            return (<Agenda
                link={getObjectUrl(siteURL, elem.event?.slug, "event", locale)}
                date={elem.event?.start_date}
                title={elem.event?.title}
            ></Agenda>);
        }

        if (elem.__typename === "CmsPortalComponentWidgetQuote") {
            return (<Citation
                text={elem.text}
                bottom={elem.block_bottom}
                alt={altNN(elem.url_alt)}
                url={elem.url}
                new_window={elem.open_in_new_window}
            ></Citation>);
        }

        if (elem.__typename === "CmsPortalComponentWidgetEvent") {
            return (<Actualite
                eventLanguage={elem.event?.evt_language}
                locale={locale}
                start_date={elem.event?.start_date}
                end_date={elem.event?.end_date}
                title={elem.event?.title}
                description={elem.event?.heading}
                image={elem.event?.cover}
                social_networks={elem.event?.social_network}
                campus={elem.event?.Campus}
                url={getObjectUrl(siteURL, elem.event?.slug, "event", locale)}
            ></Actualite>);
        }

        if (elem.__typename === "CmsPortalComponentWidgetNewsItem") {
            return (<Actualite
                title={elem.news?.title}
                description={elem.news?.heading}
                image={elem.news?.cover}
                url={getObjectUrl(siteURL, elem.news?.slug, "news_item", locale)}
                start_date={elem.news?.publishedAt}
            ></Actualite>);
        }

        if (elem.__typename === "CmsPortalComponentWidgetFocus") {
            return (<Actualite
                title={elem.title}
                description={elem.content}
                image={elem.media}
                url={elem.link}
                start_date={elem.date}
                target={(elem.new_window) ? "_blank" : ""}
            ></Actualite>);
        }

        if (elem.__typename === "CmsPortalComponentWidgetKeyFigures") return (<ChiffreCle
            figure={elem.label}
            label={elem.value}
            url={elem.URL}
            new_window={elem.new_window}
        ></ChiffreCle>);

        if (elem.__typename === "CmsPortalComponentWidgetMarketing") return (<Marketing
            text={elem.text}
            link_label={elem.target_link_label}
            alt={altNN(elem.target_link_alt)}
            link={elem.target_link_marketing}
            type={elem.type}
            image={elem.background}
            icon={elem.icon}
            color={elem.color}
        ></Marketing>);

        if (elem.__typename === "CmsPortalComponentWidgetFocusContent") return (<FocusContent
            playingVideoIndex={playingVideoIndex}
            setPlayingVideoIndex={setPlayingVideoIndex}
            index={playableIndex++}
            {...elem}
        />);

      if (elem.__typename === "CmsPortalComponentWidgetDispatch")
        return (
          <>
            <Dispatch
                {...elem}
            />
        </>);

        return <Fragment></Fragment>;
    };
    return (<>
        <div className={sectionStyles.rootSection}>
            <div className={sectionStyles.rootItem}>
                {title && (<div className={sectionStyles.rootTitle}>
                    <h2 style={{color: "var(--red-color)", margin: "0px"}}>{title}</h2>
                </div>)}
                {content?.length > 0 && (<div
                    className={sectionStyles.rootContent}
                    style={{
                        gridTemplateColumns: `repeat(${column}, 1fr)`, gap: (spacing) ? `${sizeSpacing}px` : "0",
                    }}
                >
                    {content?.map((block, firstIndex) => {
                        if (block?.widget?.content.length > 0) {
                            return (<div
                                key={`${firstIndex}`}
                                className={clsx(sectionStyles.item, {
                                    [sectionStyles.four]: block.col_span === 4,
                                    [sectionStyles.three]: block.col_span === 3,
                                    [sectionStyles.two]: block.col_span === 2,
                                })}
                                style={{
                                    gridColumn: `span ${block.col_span}`,
                                    gridRow: `span ${block.row_span}`,
                                    paddingTop: `calc(100% / ${block.col_span / block.row_span} ${(spacing) ? `- ${sizeSpacing / 2}px)` : ')'}`
                                }}
                            >
                                {chooseWidget(block?.widget?.content[0])}
                            </div>);
                        }
                        return <Fragment key={`${firstIndex}`}/>;
                    })}
                </div>)}
            </div>
        </div>
    </>);
};

export default Section;
